import { Flex } from 'common/src/designSystem/components/flex';
import { Spacer } from 'common/src/designSystem/components/spacer';
import {
    CampaignType,
    CreateCampaignEmailSenderFragment,
    CreateCampaignInfosQuery,
    EmailsSenderId
} from 'common/src/generated/types';
import { ICreateUpdateCampaignValues } from 'common/src/input/campaignInput';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import { Emptyable } from 'common/src/util/emptyable';
import * as React from 'react';
import { FormRenderProps } from 'react-final-form';
import { Button } from '../../../designSystem/components/button';
import { CreateCampaignTextEmail } from './createCampaignTextEmail';
import { CreateCampaignTextSms } from './createCampaignTextSms';

interface ICreateCampaignTextProps {
    campaignType: 'event' | 'organization';
    customDocuments: NonNullable<
        CreateCampaignInfosQuery['organization']['event']
    >['customDocuments'];
    emailSenderId: Emptyable<EmailsSenderId>;
    emailsSenders: CreateCampaignEmailSenderFragment[];
    formProps: FormRenderProps<ICreateUpdateCampaignValues>;
    isEdit: boolean;
    isSent: boolean;
    isTemplate: boolean;
}

export const CreateCampaignText = (props: ICreateCampaignTextProps) => {
    const translate = useTranslate();

    return (
        <>
            {props.formProps.values.campaign.campaignType === CampaignType.Email ? (
                <CreateCampaignTextEmail
                    campaignType={props.campaignType}
                    customDocuments={props.customDocuments}
                    emailSenderId={props.emailSenderId}
                    emailsSenders={props.emailsSenders}
                    form={props.formProps.form}
                    values={props.formProps.values}
                />
            ) : (
                <CreateCampaignTextSms formProps={props.formProps} />
            )}

            <Spacer height="7" />

            <Flex>
                <Button
                    isLoading={props.formProps.submitting}
                    onClick={props.formProps.handleSubmit}
                >
                    {props.isTemplate
                        ? props.isEdit
                            ? translate('mettre_jour_l_13576')
                            : translate('cr_er_le_mod_le_06346')
                        : props.isSent
                          ? translate('mettre_jour_l_32694')
                          : translate('suivant_desti_10756')}
                </Button>
            </Flex>
        </>
    );
};
